<template>

  <div class="dashboard" :key="componentKey">

    <!-- Ad: Bwin Bannner -->
    <!-- <BwinBanner></BwinBanner> -->

    <div v-if="this.$store.state.betgame && this.$store.state.betgame.id === 111992" class="adbanner">
      <a href="https://www.awin1.com/cread.php?awinmid=116591&awinaffid=1610158&clickref=Banner+TT+Home&ued=https%3A%2F%2Fwolt.com%2Fde%2Fdiscovery" target="_blank" data-testid="dashboard-ad"><img src="../assets/images/teamtip/Wolt_600x150.jpg" alt="Wolt"></a> 
    </div>
    
    <ValidationPending v-if="!enterCodeClicked && this.$store.state.user && this.$store.state.user.status === 'validation_pending'"></ValidationPending>
    
    <!-- Profile Card -->
    <ProfileCard v-if="userRanking || !this.hasSeasonStarted()"></ProfileCard>

    <!--
    <PlayoffHint v-if="this.$store.state.betgame && this.$store.state.betgame.competition && 
                    this.$store.state.betgame.competition.id === 122 && !this.allMatchesFinished()"></PlayoffHint>
    -->
    
    <div v-if="this.isFutureSeason() && !this.isScheduled17()" class="notification" style="padding: 16px; border-radius: 10px; border: #3800E5 4px solid; background-color: white; 
                   margin: 16px auto 0px; max-width: 458px; margin-bottom: 24px;">
      <p data-testid="dashboard-season-hint">{{ $t('dashboard.new_season_hint') }}</p>
    </div>
    
    <div v-if="!hideSpecialQuestionHintClicked && showSpecialQuestionMissingSolutionHint && this.allMatchesFinished()"
         style="border-radius: 10px; border: #F54D42 4px solid; padding: 5px; background-color: white; 
                 margin: 16px auto 0px; max-width: 458px; margin-bottom: 24px;">
      <div class="dashboard-text" style="padding: 2px;">
        <p style="color: #5F5D61" data-testid="dashboard-special-hint">{{ $t('dashboard.special_question_missing_solution_hint') }}</p>
        <router-link :to="{name: 'betgameeditspecialquestions'}">
          <button style="margin-top: 10px;" id="special_question_solutions_hint" data-testid="dashboard-special-solutions">{{ $t('dashboard.special_question_missing_solution_hint_button_text') }}</button>
        </router-link>
        <button v-on:click="hideSpecialQuestionMissingSolutionHint()" style="margin-top: 10px;" data-testid="dashboard-hide-hint">{{ $t('hide_hint') }}</button>
      </div>
    </div>
    <div v-else-if="!hideSpecialQuestionHintClicked && this.specialQuestionMissingSolutions() && 
      (this.allMatchesFinished() || this.$store.state.betgame && this.$store.state.betgame.id === 93692)" style="border-radius: 10px; border: #F54D42 4px solid; padding: 5px; background-color: white; 
                   margin: 16px auto 0px; max-width: 458px; margin-bottom: 24px;">
      <div class="dashboard-text" style="padding: 2px;">
        <p style="color: #5F5D61" data-testid="dashboard-special-hint">{{ $t('dashboard.special_question_missing_solution_hint_user') }}</p>
        <button v-on:click="mailToBetgameAdmin()" style="margin-top: 10px;" data-testid="contact-admin">{{ $t('user_betgame_settings.button_contact_betgame_admin') }}</button>
        <button v-on:click="hideSpecialQuestionMissingSolutionHint()" style="margin-top: 10px;" data-testid="dashboard-hide-hint">{{ $t('hide_hint') }}</button>
      </div>
    </div>

    <div v-if="!this.hideCreateBetgameAd && this.isBetgame() && this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 139 && this.isAdmin(this.$store.state.betgame.id)" style="margin-bottom: 24px;" class="adbanner">
      <div @click="hideCreateBetgameAdClicked" class="adbanner__close" data-testid="dashboard-ad-close"></div>
      <img v-if="this.$store.state.language === 'de'" v-on:click="copyBetgame(1)" data-testid="dashboard-copy-betgame" src="../assets/images/teamtip/202627_a_de.png" alt="">
      <img v-else-if="this.$store.state.language === 'fr'" v-on:click="copyBetgame(71)" data-testid="dashboard-copy-betgame" src="../assets/images/teamtip/202627_a_fr.png" alt="">
      <img v-else v-on:click="copyBetgame(91)" data-testid="dashboard-copy-betgame" src="../assets/images/teamtip/202627_a_en.png" alt="">
    </div>
    <div v-else-if="!this.hideCreateBetgameAd && this.isBetgame() && this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 139 && !this.isAdmin(this.$store.state.betgame.id)" style="margin-bottom: 24px;" class="adbanner">
      <div @click="hideCreateBetgameAdClicked" class="adbanner__close" data-testid="dashboard-ad-close"></div>
      <img v-if="this.$store.state.language === 'de'" v-on:click="createBetgame" data-testid="dashboard-create-betgame" src="../assets/images/teamtip/202627_u_de.png" alt="">
      <img v-else-if="this.$store.state.language === 'fr'" v-on:click="createBetgame" data-testid="dashboard-create-betgame" src="../assets/images/teamtip/202627_u_fr.png" alt="">
      <img v-else v-on:click="createBetgame" data-testid="dashboard-create-betgame" src="../assets/images/teamtip/202627_u_en.png" alt="">
    </div>
    
    <!--
    <div v-if="!hideCreateWMBetgameAd && this.isBetgame() && this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id !== 139 && this.isAdmin(this.$store.state.betgame.id)" style="margin-bottom: 24px;" class="adbanner">
      <div @click="hideCreateWMBetgameAdClicked" class="adbanner__close"></div>
      <img v-if="this.$store.state.language === 'de'" v-on:click="copyBetgame" src="../assets/images/teamtip/switch_banner_de.png" alt="">
      <img v-else v-on:click="copyBetgame" src="../assets/images/teamtip/switch_banner_en.png" alt="">
    </div>
    <div v-else-if="!hideCreateWMBetgameAd && this.$store.state.betgame && this.$store.state.betgame.competition && this.$store.state.betgame.competition.id !== 139" style="margin-bottom: 24px;" class="adbanner">
      <div @click="hideCreateWMBetgameAdClicked" class="adbanner__close"></div>
      <img v-if="this.$store.state.language === 'de'" v-on:click="createBetgame" data-testid="dashboard-create-betgame" src="../assets/images/teamtip/wm2026_de.png" alt="">
      <img v-else v-on:click="createBetgame" data-testid="dashboard-create-betgame" src="../assets/images/teamtip/wm2026_en.png" alt="">
    </div>
    -->
    
    <!--
    <div v-if="this.isBetgameAdmin() && !this.hideCreateBetgameAd && this.$store.state.betgame && this.$store.state.betgame.type === 1 && this.$store.state.betgame.season.id === 15 && this.$store.state.betgame.competition.id !== 588 && this.$store.state.betgame.competition.id !== 1180 && this.$store.state.betgame.competition.id !== 1235" 
         style="margin-bottom: 24px;" class="adbanner">
      <img v-if="this.$store.state.language === 'de'" v-on:click="copyBetgame" src="../assets/images/teamtip/teamtip_neue_saison-de-600x200.png" alt="">
      <img v-else v-on:click="copyBetgame" src="../assets/images/teamtip/teamtip_new_season-en-600x200.png" alt="">
    </div>
    <div v-else-if="!this.isBetgameAdmin() && !this.hideCreateBetgameAd && this.$store.state.betgame && this.$store.state.betgame.type === 1 && this.$store.state.betgame.season.id < 16" style="margin-bottom: 24px;" class="adbanner">
      <div @click="hideCreateBetgameAdClicked" class="adbanner__close" data-testid="dashboard-ad-close"></div>
      <img v-if="this.$store.state.language === 'de'" style="margin-top: 16px;" v-on:click="createBetgame" data-testid="dashboard-create-betgame" src="../assets/images/teamtip/teamtip_dashboard_start_202526.png" alt="">
      <img v-else v-on:click="createBetgame" data-testid="dashboard-create-betgame" style="margin-top: 16px;" src="../assets/images/teamtip/teamtip_dashboard_start_202526_en.png" alt="">
    </div>
    -->
    
    <!--<FutureScheduleHint v-if="this.isFutureSeason() && !this.isScheduled()"></FutureScheduleHint>-->
    
    <CopyBetgame v-if="this.isBetgameAdmin && this.$store.state.betgame && this.$store.state.betgame.type === 1 && this.$store.state.betgame.season.id === 16 && this.copyBetgameAvailable(this.$store.state.betgame.competition)"></CopyBetgame>
    
    <!-- Optional: Nur sichtbar, wenn Tipprunde/Saison vorbei -->
    <BetgameFinished v-if="this.allMatchesFinished() && !this.specialQuestionMissingSolutions()"></BetgameFinished>
    
    <!-- Optional: Nur sichtbar, wenn User Spieltagssieger des letzten abgelaufenen Spieltags ist -->
    <MatchdayWinner v-if="this.isBetgame() && nextMatch && lastMatchdayWon && !matchRunning && allMathdayMatchesFinished && !currentMatchdayStartsTodayTomorrow"></MatchdayWinner>

    <MatchdayPreview v-if="this.$store.state.betgame && this.$store.state.betgame.competition && 
                this.$store.state.betgame.competition.type === 'TOURNAMENT' && !this.allMatchesFinished() && !matchRunning 
                && !todaysMatchdayStarted && !nextMatch"></MatchdayPreview>
    <!-- Nächster Spieltag / Countdown -->
    <!-- Optional: Nur sichtbar, wenn kein aktiver Spieltag -->
    <MatchdaySlider v-if="(!hasTodaysMatches || matchdayCountdown) && this.$store.getters.getLiveMatches.length === 0 && !this.allMatchesFinished() && !todaysMatchdayStarted && nextMatch"></MatchdaySlider>

    <!-- Aktiver Spieltag -->
    <DashboardLiveStatisticsOneMatch v-if="this.selectedDashboardLiveView === 1" :match="singleMatch"></DashboardLiveStatisticsOneMatch>
    <DashboardLiveStatisticsTwoMatches v-else-if="this.selectedDashboardLiveView === 2" :matches="twoMatches"></DashboardLiveStatisticsTwoMatches>
    <DashboardLiveStatisticsMultipleMatches v-else-if="this.selectedDashboardLiveView === 3" :runningMatchday="this.runningMatchday"></DashboardLiveStatisticsMultipleMatches>
    
    <!-- Gesamtwertung -->
    <DashboardRanking :rankings="dashboardRankings"></DashboardRanking>

    <!-- Formkurve -->
    <DashboardTrendbox v-if="this.isBetgame() && !this.isTournament()"></DashboardTrendbox>
    
    <AppstauberWidget v-if="!this.hideAppstauber()"></AppstauberWidget>
    
    <!-- Beschreibung -->
    <BetgameDescription></BetgameDescription>

  </div>
</template>

<script>
import NavigationBar from './../components/NavigationBar'
import BwinBanner from './../components/BwinBanner'
import ProfileCard from './../components/ProfileCard'
import MatchdaySlider from './../components/MatchdaySlider'
import DashboardRanking from './../components/DashboardRanking'
import DashboardTrendbox from './../components/DashboardTrendbox'
import BetgameDescription from './../components/BetgameDescription'
import moment from 'moment/moment'
import DashboardLiveStatisticsOneMatch from '@/components/DashboardLiveStatisticsOneMatch.vue'
import DashboardLiveStatisticsTwoMatches from '@/components/DashboardLiveStatisticsTwoMatches.vue'
import DashboardLiveStatisticsMultipleMatches from '@/components/DashboardLiveStatisticsMultipleMatches.vue'
import MatchdayWinner from '@/components/MatchdayWinner.vue'
import Vue from 'vue'
import jwt_decode from 'jwt-decode'
import {
  SCHEDULED, SPORTS_TYPE_DARTS, SPORTS_TYPE_FOOTBALL, SPORTS_TYPE_HANDBALL,
  SPORTS_TYPE_HOCKEY, SPORTS_TYPE_ICE_HOCKEY, SPORTS_TYPE_NFL,
  SPORTS_TYPE_OLYMPIA, TYPE_TEAMS_ID
} from '@/main'
import ValidationPending from '@/views/ValidationPending.vue'
import MatchdayPreview from '@/components/MatchdayPreview.vue'
import Dashboard from '@/views/Dashboard.vue'
import BetgameFinished from '@/components/BetgameFinished.vue'
import CopyBetgame from '@/components/CopyBetgame.vue'
import FutureScheduleHint from '@/components/FutureScheduleHint.vue'
import AppstauberWidget from '@/components/AppstauberWidget.vue'
import PlayoffHint from '@/components/PlayoffHint.vue'

export default {
  name: 'DashboardNew',
  components: { PlayoffHint, AppstauberWidget, FutureScheduleHint, CopyBetgame, Dashboard, MatchdayPreview, ValidationPending, MatchdayWinner, DashboardLiveStatisticsOneMatch, DashboardLiveStatisticsTwoMatches, DashboardLiveStatisticsMultipleMatches, NavigationBar, BwinBanner, ProfileCard, MatchdaySlider, DashboardRanking, DashboardTrendbox, BetgameDescription, BetgameFinished },
  data () {
    return {
      pushParameter: '',
      hideSpecialQuestionHintClicked: (window.localStorage.getItem('hideSpecialQuestionMissingSolutionHint') !== undefined &&
        window.localStorage.getItem('hideSpecialQuestionMissingSolutionHint') !== null &&
        (window.localStorage.getItem('hideSpecialQuestionMissingSolutionHint') === 1 ||
          window.localStorage.getItem('hideSpecialQuestionMissingSolutionHint') === "1")),
      hideCreateBetgameAd: (window.localStorage.getItem('hideCreateBetgameAd') !== undefined &&
        window.localStorage.getItem('hideCreateBetgameAd') !== null &&
        (window.localStorage.getItem('hideCreateBetgameAd') === 1 ||
          window.localStorage.getItem('hideCreateBetgameAd') === "1")),
      hideCreateWMBetgameAd: (window.localStorage.getItem('hideCreateWMBetgameAd1') !== undefined &&
        window.localStorage.getItem('hideCreateWMBetgameAd1') !== null &&
        (window.localStorage.getItem('hideCreateWMBetgameAd1') === 1 ||
          window.localStorage.getItem('hideCreateWMBetgameAd1') === "1")),
      componentKey: 0
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from.name
    })
  },
  beforeCreate () {
    Vue.$log.debug('DashboardNew beforeCreate')
    this.$router.push('/feed/dashboard').catch(err => {})
  },
  created () {
    Vue.$log.debug('DashboardNew created ' + this.$route.query.push)

    this.pushParameter = this.$route.query.push
    
    if(this.$store.state.betgame && this.$store.state.betgame.fk_user && this.$store.state.user && this.$store.state.betgame.fk_user === this.$store.state.user.id) {
      const d = new Date();
      d.setTime(d.getTime() + (1*24*60*60*1000));
      let expires = "expires="+ d.toUTCString();
      document.cookie = "SPMAUTH=1;" + expires + ";path=/";
    } else {
      document.cookie = 'SPMAUTH=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/'
    }
    
    if(this.$store.state.betgameId) {
      this.$store.dispatch('fetchBetgame', this.$store.state.betgameId)
    }

    if(this.$store.state.betgame && this.$store.state.user) {
      this.$store.dispatch('fetchUserLiveRanking', {}).then(() => {
        this.componentKey += 1
      })
    }
          
    if(this.$store.state.betgame && this.$store.state.betgame.type === TYPE_TEAMS_ID && (!this.$store.state.betgameTeams || this.$store.state.betgameTeams.length === 0)) {
      this.$store.dispatch('fetchBetgameTeams', this.$store.state.betgameId).then(() => {
        this.$store.dispatch('fetchSchedule', this.$store.state.leagueId).then(() => {
        })
      })
    }

    const lastFetchSchedule = this.getBGValue('spmlfs')
    const duration2 = (new Date() - new Date(lastFetchSchedule)) / 1000
    const cachingDuration = Math.min(this.$store.getters.getCachingDuration, 60)
    if ((lastFetchSchedule !== null && duration2 > cachingDuration) || this.$store.state.matches == null || this.$store.state.matches.length === 0) {
      this.$store.dispatch('fetchSchedule', this.$store.state.leagueId).then(() => {
      })
    }
    
    if (this.$store.state.teams.length === 0 && this.$store.state.betgameId) {
      this.$store.dispatch('fetchTeams', this.$store.state.betgameId)
    }

    if (this.$store.state.betgame && this.$store.state.betgame.competition &&
        this.$store.state.betgame.competition.type === 'TOURNAMENT') {
      if (this.$store.state.tournamentRounds.length === 0 || this.$store.state.tournamentMatches.length === 0) {
        if (this.$store.state.betgame.season) {
          this.$store.dispatch('fetchTournamentRounds', {
            fk_competition: this.$store.state.betgame.competition.id,
            fk_season: this.$store.state.betgame.season.id
          }).then(() => {
          })
        }
      }
    }

    if(this.$store.state.competitions.length === 0) {
      this.$store.dispatch('fetchCompetitions', '')
    }
    if(this.$store.state.betgame && !this.nextMatch) {
      const trackLoadingOverlay = !this.$store.getters.hasCachedDashboardData
      if (this.isBattle() || this.isTeamsBetgame()) {
        if (trackLoadingOverlay) {
          this.$store.dispatch('updateShowLoadingOverlayStatus', 1)
        }
        this.$store.dispatch('fetchLiveRanking', [this.$store.state.betgame.id, this.$store.state.leagueId, 0]).then(() => {
        })
      } else {
        if (trackLoadingOverlay) {
          this.$store.dispatch('updateShowLoadingOverlayStatus', 1)
        }
        this.$store.dispatch('fetchBetgameRankings', { fk_betgame: this.$store.state.betgame.id }).then(function (response) {
        })
      }
    }

    setTimeout(() => this.loadDeferredDashboardData(), 0)
  },
  mounted () {
    Vue.$log.debug('DashboardNew mounted specialQuestionMissingSolutions ' + this.specialQuestionMissingSolutions() + ' ---- allMatchesFinished ' + this.allMatchesFinished())
    if(navigator.userAgent.indexOf('TEAMTIP') > 0 || navigator.userAgent.indexOf('Teamtip') > 0) {
      window.cmp_noscreen = true
    }
    
    this.$store.dispatch('fetchRankingsSize').then(response => {})
    
    if(this.$store.state.betgameId && parseInt(this.$store.state.betgameId) > 0) {
      Vue.$log.debug('dashboard mounted fetchBetgameUsers ' + this.$store.state.betgameId)
      if(!this.$store.state.userCount || this.$store.state.userCount < 1) {
        this.$store.dispatch('fetchUserCount', 'planned').then(response => {
          Vue.$log.debug('dashboard mounted fetchUserCount ' + this.$store.state.userCount)
          if(this.$store.state.userCount && this.$store.state.userCount <= 1000) {
            //this.$store.dispatch('fetchBetgameUsers', this.$store.state.betgameId)
          }
        })
      } else if(this.$store.state.userCount && this.$store.state.userCount <= 1000) {
        //this.$store.dispatch('fetchBetgameUsers', this.$store.state.betgameId)
      }
    }

    if(this.$store.state.user && this.$store.state.betgameId && (!this.$store.state.bets || this.$store.state.bets.length === 0)) {
      this.$store.dispatch('fetchBets', this.$store.state.user.id).then(() => {
      })
      if(this.showBetgamePointsHint || this.showBetgamePointsHintUser) {
        this.$store.dispatch('fetchBetgame', this.$store.state.betgameId)
      }
    }
    if(this.$store.state.betgameId && parseInt(this.$store.state.betgameId) > 0) {
      if (this.$store.state.leagueId && !this.isTournament()) {
        this.$store.dispatch('fetchMatchdayWins', this.$store.state.betgameId).then(() => {
        })
      } else {
        if(!this.$store.state.leagueId || !this.$store.state.betgame.competition || !this.$store.state.betgame.season) {
          this.$store.dispatch('fetchBetgameLeague', this.$store.state.betgameId).then(() => {
          })
        } else {
        }
      }
      
      if(this.isBattle()) {
        const lastFetchLiveRanking = this.getBGValue('spmlflr')
        const duration1 = (new Date() - new Date(lastFetchLiveRanking)) / 1000
        if (duration1 > this.$store.getters.getCachingDuration || this.$store.state.liveRankings == null || this.$store.state.liveRankings.length === 0 ||
            this.$store.state.allbets == null || this.$store.state.allbets.length === 0) {
          this.$store.dispatch('fetchLiveRanking', [this.$store.state.betgameId, this.$store.state.leagueId, 0]).then(() => {
            this.setBGValue('spmlflr', new Date())
          })

        }
      } else if(this.isTeamsBetgame()) {
        const lastFetchLiveRanking = this.getBGValue('spmlflr')
        const duration1 = (new Date() - new Date(lastFetchLiveRanking)) / 1000
        if (duration1 > this.$store.getters.getCachingDuration || this.$store.state.liveRankings == null || this.$store.state.liveRankings.length === 0 ||
            this.$store.state.allbets == null || this.$store.state.allbets.length === 0) {
          this.$store.dispatch('fetchLiveRanking', [this.$store.state.betgameId, this.$store.state.leagueId, 0]).then(() => {
            this.setBGValue('spmlflr', new Date())
          })

        }
      } else {
        const lastFetchLiveRanking = this.getBGValue('spmlflr')
        const duration1 = (new Date() - new Date(lastFetchLiveRanking)) / 1000
        if (duration1 > this.$store.getters.getCachingDuration || this.$store.state.liveRankings == null || this.$store.state.liveRankings.length === 0 ||
            this.$store.state.allbets == null || this.$store.state.allbets.length === 0) {
          if (this.$store.state.leagueId && this.$store.state.betgameId) {
            this.$store.dispatch('fetchLiveRanking', [this.$store.state.betgameId, this.$store.state.leagueId, 0]).then(() => {
            })
          }
        }
      }

      if(this.previousRoute && this.previousRoute !== 'dashboard' && this.previousRoute !== 'mybetgames') {
        if(this.showSPMReviewPopup()) {
          this.requestReview()
        }
      }
    } else {
      if(this.$store.getters.userBetgamesCount > 0) {
        Vue.$log.debug('dashboard mounted !this.$store.state.betgameId /mybetgames')
        this.$router.push('/mybetgames')
      } else {
        Vue.$log.debug('dashboard mounted !this.$store.state.betgameId /searchbetgame')
        this.$router.push('/searchbetgame')
      }
    }
    
    /*
    if(this.$store.state.betgame && this.$store.state.user) {
      const uid = '' + this.$store.state.user.id
      const uem = '' + this.$store.state.user.email.charAt(0) + this.reverse(uid)
      const temp = this.reverse(String(this.$store.state.user.registration_date)).replaceAll('T', this.reverse(uem))
      .replaceAll(':', '').replaceAll('-', uem).concat(uid)
      if(!this.$store.state.chat_token || this.$store.state.chat_token === '') {
        if(this.$store.state.user.chatuser && this.$store.state.user.chatuser !== '') {
            this.$store.dispatch('chatLoginUser', {'user': uid, 'password': temp}).then(response => {
              this.$log.debug('dashboard mounted chatLoginUser response: ' + JSON.stringify(response))
              this.$store.dispatch('fetchChatItems', true)
              this.$store.dispatch('patchUser', {
                chatuser: uid + '-' + temp
              })
            })
        } 
      } else {
        const payload = jwt_decode(JSON.stringify(this.$store.state.chat_token))
        const a = payload.exp * 1000
        const b = moment()
        if(a < b) {
          this.$store.dispatch('chatLoginUser', {'user': uid, 'password': temp}).then(response => {
            this.$log.debug('app mounted chatLoginUser response: ' + JSON.stringify(response))
            this.$store.dispatch('fetchChatItems', true)
          })
        }
        if(!this.$store.state.user.chatuser.includes('-')) {
          this.$store.dispatch('patchUser', {
            chatuser: uid + '-' + temp
          })
        }
      }
    }
    */
    
    if(this.$store.state.user) {
      if(!this.$store.state.user.source || this.$store.state.user.source === '') {
        if(this.userSource && this.userSource !== '' && this.userSource.length > 0 && this.userSource.length < 100) {
          this.$store.dispatch('patchUser', {
            source: this.userSource
          })
        }
      }
    } 
    
    this.finishDashboardLoad()

    if(this.$store.state.betgame) {
      this.styleDocument()
    }

    // appstauber
    const t1 = document.querySelector('app-stauber')
    if (t1) {
      this.$store.dispatch('setHideAppstauber', false)
      t1.addEventListener('campaign-list-empty', (e) => {
        this.$store.dispatch('setHideAppstauber', true)
      })
    }
    const appstauberDelay = this.$store.getters.hasCachedDashboardData ? 300 : 1000
    setTimeout(() => {
      const t = document.querySelector('app-stauber')
      if (t) {
        t.addEventListener('component-visible', (e) => {
          if (this.$store.state.appstauberConfig) {
            this.$store.dispatch('setAppstauberId', this.$store.state.appstauberConfig.id)
          }
        })
        t.addEventListener('campaign-list-empty', (e) => {
          this.$store.dispatch('setHideAppstauber', true)
        })
      }
    }, appstauberDelay)
  },
  computed: {
    userlang () {
      return this.$store.state.language
    },  
    userRanking() {
      if(this.$store.state.userLiveRanking) {
        return this.$store.state.userLiveRanking
      } else if(this.$store.state.liveRankings && this.$store.state.user) {
        const r = this.$store.state.liveRankings.filter(r => r.fk_user === this.$store.state.user.id)
        if(r && r.length > 0) {
          return r[0]
        }
      }
      return null
    },
    userSource() {
      return window.localStorage.getItem('userSource') || ''
    },
    showSpecialQuestionMissingSolutionHint() {
      const t = window.localStorage.getItem('hideSpecialQuestionMissingSolutionHint')
      if(t !== undefined && t != null && (t === 1 || t === '1')) {
        return false
      }
      if(this.$store.state.betgame && this.$store.state.user && this.$store.state.betgame.fk_user === this.$store.state.user.id) {
        const quests = this.$store.state.questions.filter(q => parseInt(q.fk_betgame) === parseInt(this.$store.state.betgame.id))
        if(!quests || quests.length === 0) {
          return false
        }
        var result = false
        for(var i=0; i<quests.length; i++) {
          const eu = this.parseMatchdate(quests[i].editable_until)
          if (eu < Date.now()) {
            const solutions = this.$store.state.solutions.filter(s => s.fk_question === quests[i].id)
            result = !solutions || solutions.length < quests[i].answer_count
            if (result) {
              return true
            }
          }
        }
      }
      return false
    },
    enterCodeClicked() {
      return this.getBGValue('spmvr')
    },
    lastMatchdayWon() {
      if(this.nextMatch && this.nextMatch.matchday > 1) {
        if (this.matchdayWins.length > 0) {
          const temp = this.matchdayWins.filter(matchdayWin => matchdayWin.matchday === (this.nextMatch.matchday - 1))
          if(temp.length > 0) {
            const t = temp[0]
            if(t.points_total > 0) {
              return true
            }
          }
        }
      }
      return false
    },
    matchdayWins() {
      if(this.$store.state.user) {
        return this.$store.getters.getMatchdayWins(this.$store.state.user.id)
      }
      return []
    },
    allMathdayMatchesFinished() {
      if(this.nextMatch && this.nextMatch.matchday > 1) {
        const matchdayMatches = this.$store.getters.getMatchesByMatchday(this.nextMatch.matchday - 1)
        for (var i = 0; i < matchdayMatches.length; i++) {
          const match = matchdayMatches[i]
          if (!this.isNumeric(match.goalshome) || !this.isNumeric(match.goalsguest)) {
            return false
          }
        }
        return matchdayMatches.length > 0
      }
      return false
    },
    currentMatchdayStartsTodayTomorrow() {
      if(this.nextMatch && this.nextMatch.matchday > 1) {
        const matchdayMatches = this.$store.getters.getMatchesByMatchday(this.nextMatch.matchday)
        for (var i = 0; i < matchdayMatches.length; i++) {
          const match = matchdayMatches[i]
          if(this.isToday(match.matchdate) || this.isTomorrow(match.matchdate)) {
            return true
          }
        }
        return false
      }
      return false
    },
    matchRunning() {
      return this.$store.getters.getLiveMatch
    },
    nextMatch() {
      if(this.$store.state.matches.length > 0) {
        return this.$store.getters.getClosestFutureMatch
      } else {
        if(this.$store.state.leagueId) {
          this.$store.dispatch('fetchSchedule', this.$store.state.leagueId)
        } else {
          if(this.getBGValue('spmbgid') && parseInt(this.getBGValue('spmbgid')) > 0) {
            this.$store.dispatch('fetchBetgameLeague', this.getBGValue('spmbgid'))
          }
        }
      }
    },
    matchdayCountdown() {
      if(this.isBetgame()) {
        if(this.$store.state.runningMatches.length === 0 || !this.checkStatus(this.$store.state.runningMatches)) {
          for(var i=0; i<this.$store.state.todaysMatches.length; i++) {
            const matchid = this.$store.state.todaysMatches[i]
            const match = this.$store.getters.getMatcheById(matchid)
            if((match.livegoalshome !== null && match.livegoalsguest !== null) || (match.goalshome !== null && match.goalsguest !== null)) {
              return false
            }
          }
          return true
        }
      }
      return false
    },
    todaysMatchdayStarted() {
      return this.$store.getters.getTodaysMatchesMatchdayStarted
    },
    hasTodaysMatches() {
      return this.$store.state.todaysMatches.length > 0
    },
    singleMatch() {
      const lm = this.$store.getters.getLiveMatches.filter(m => m.fk_competition === 139)
      if(this.$store.state.betgame && (lm.length > 0 || (this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 139))) {
        if(lm.length === 1) {
          const match = lm[0]
          if(match && match.id) {
            return this.$store.getters.getMatcheById(match.id)
          }
        }
      }
      return this.$store.getters.getMatcheById(this.$store.state.todaysMatches[0])
    },
    twoMatches() {
      const lm = this.$store.getters.getLiveMatches.filter(m => m.fk_competition === 139)
      if(this.$store.state.betgame && (lm.length > 0 || (this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 139))) {
        if(lm.length === 2) {
          const match1 = lm[0]
          const match2 = lm[1]
          if(match1 && match2 && match1.id && match2.id) {
            return [this.$store.getters.getMatcheById(match1.id), this.$store.getters.getMatcheById(match2.id)]
          }
        }
      }
      const m = [this.$store.getters.getMatcheById(this.$store.state.todaysMatches[0]),
        this.$store.getters.getMatcheById(this.$store.state.todaysMatches[1])]
      m.sort(function (a, b) {
        return a.matchdate !== b.matchdate ? Date.parse(a.matchdate) - Date.parse(b.matchdate) : a.id - b.id
      })
      return m
    },
    runningMatchday() {
      const today = this.$store.state.todaysMatches
      if (today.length > 0) {
        const match = this.$store.getters.getMatcheById(today[0])
        return match.matchday
      }
      const t = this.getRunningMatchdays
      return t.length > 0 ? t[0].matchday : 0
    },
    selectedDashboardLiveView() {
      const lm = this.$store.getters.getLiveMatches.filter(m => m.fk_competition === 139)
      if(this.$store.state.betgame && (lm.length > 0 || (this.$store.state.betgame.competition && this.$store.state.betgame.competition.id === 139))) {
        if(lm.length === 1) {
          const match = lm[0]
          if(match && match.id) {
            return 1
          }
        } else if(lm.length === 2) {
          const match1 = lm[0]
          const match2 = lm[1]
          if(match1 && match2 && match1.id && match2.id) {
            return 2
          }
        }
      }
      if(this.$store.state.betgame && this.$store.state.betgame.type === 1) {
        if(this.getRunningMatchdays.length !== 1) {
          //return 0
        }
        if(this.$store.state.leagueId === 1 || this.$store.state.leagueId === 2 || this.$store.state.leagueId === 998) {
          var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
          if(!timeZone) {
            timeZone = 'Europe/Berlin'
          }
          const nowww = moment.tz(timeZone)
          const t = this.calcMatchdayStartEnd
          for(var i=1; i<t.length; i++) {
            if(t[i] && t[i].start && t[i].end) {
              const matchdayStart = moment.tz(String(t[i].start), timeZone)
              const matchdayEnd = moment.tz(String(t[i].end), timeZone)
              matchdayEnd.add(1, 'days').endOf('day')
              if(nowww.isBetween(matchdayStart, matchdayEnd) && t[i].days <= 7) {
                return 3
              }
            }
          }
          if(this.$store.state.todaysMatches.length === 1) {
            return 1
          } else if(this.$store.state.todaysMatches.length === 2) {
            return 2
          }
        } else {
          if(this.$store.getters.getTodaysMatchesMatchdayStarted) {
            if (this.$store.state.todaysMatches.length > 2) {
              return 3
            } else if (this.$store.state.todaysMatches.length === 2) {
              return 2
            } else if (this.$store.state.todaysMatches.length === 1) {
              return 1
            } else {
              return 0
            }
          } else {
            return 0
          }
        }
      } else if(this.$store.state.betgame && this.$store.state.betgame.type === 2) {
        if(this.$store.state.todaysMatches.length > 2) {
          return 3
        } else if(this.$store.state.todaysMatches.length === 2) {
          return 2
        } else if(this.$store.state.todaysMatches.length === 1) {
          return 1
        } else {
          return 0
        }
      } else if(this.$store.state.betgame && this.$store.state.betgame.type === 3) {
        if(this.$store.state.todaysMatches.length > 2) {
          return 3
        } else if(this.$store.state.todaysMatches.length === 2) {
          return 2
        } else if(this.$store.state.todaysMatches.length === 1) {
          return 1
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    getRunningMatchdays() {
      const matchdays = this.calcMatchdayStartEnd
      var result = []
      var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      if(!timeZone) {
        timeZone = 'Europe/Berlin'
      }
      const nowww = moment.tz(timeZone)
      for(var i=0; i<matchdays.length; i++) {
        const matchday = matchdays[i]
        if(matchday && matchday.start && matchday.end) {
          const start = this.parseMatchdate(matchday.start)
          const end = this.parseMatchdate(matchday.end)

          const matchdayStart = moment.tz(String(matchday.start), timeZone)
          const matchdayEnd = moment.tz(String(matchday.end), timeZone)
          matchdayEnd.add(1, 'days').endOf('day')
          if(start && end && matchday.days <= 7) {
            if(start.isSame(moment(Date.now()), 'day') || end.isSame(moment(Date.now()), 'day') ||
                (start.isBefore(moment(Date.now()), 'day') && end.isAfter(moment(Date.now()), 'day'))) {
              result.push(matchday)
            } else if(nowww.isBetween(matchdayStart, matchdayEnd)) {
              result.push(matchday)
            }
          }
        }
      }
      return result
    },
    calcMatchdayStartEnd() {
      const matchesByMathday = this.groupMatchesByMathday
      var result = []
      for(var matchday = 0; matchday < matchesByMathday.length; matchday++) {
        const matchdayMatches = matchesByMathday[matchday]
        if(matchdayMatches) {
          const sorted = matchdayMatches.sort(function (a, b) {
            return Date.parse(a.matchdate) - Date.parse(b.matchdate)
          })
          const matchdayStart = sorted[0].matchdate
          const matchdayEnd = sorted[sorted.length - 1].matchdate
          const diffInDays = 1 + Math.floor((Date.parse(matchdayEnd) - Date.parse(matchdayStart)) / (1000 * 60 * 60 * 24))
          result[matchday] = {
            start: matchdayStart,
            end: matchdayEnd,
            days: diffInDays,
            matchday: matchday
          }
        }
      }
      return result
    },
    groupMatchesByMathday() {
      var result = []
      for(var i = 0; i < this.$store.state.matches.length; i++) {
        const match = this.$store.state.matches[i]
        if(result[match.matchday] === undefined) {
          result[match.matchday] = []
        }
        result[match.matchday].push(match)
      }
      return result
    },
    dashboardRankings() {
      if(true || this.hasSeasonStarted()) {
        if (!this.$store.state.rankingsMeighbors) {
          if (!this.$store.state.leagueId && this.getBGValue('spmbgid') && parseInt(this.getBGValue('spmbgid')) > 0) {
            this.$store.dispatch('fetchBetgameLeague', this.getBGValue('spmbgid'))
          }
        }
        return this.$store.getters.getRankingForDashboard
      } else {
        var r = this.$store.state.betgameUsers
        if(!r) {
          return []
        }
        if(r.length > 15) {
          r = r.slice(0, 15)
        }
        var result = []
        for(var i=0; i<r.length; i++) {
          result.push({"position": i+1, "fk_betgame": this.$store.state.betgameId, 
            "fk_competition": 0, "fk_user": r[i].fk_user, "user_name": r[i].nickname, 
            "points_total":0,"bet_points":0,"question_points":0,"points_correction":0,"matchday_wins":0,"exact":0,"goaldiff":0,
            "tendency":0,"no_points":81,"betcount":81,"position_int":1})
        }
        return result
      }
    },
    betgameUsers () {
      const r = this.$store.state.betgameUsers
      if(!r) {
        return []
      }
      if(r.length > 100) {
        return r.slice(0, 100)
      }
      return r
    },
    betgameName() {
      if(this.$store.state.betgame) {
        return this.$store.state.betgame.name
      } else {
        if(this.getBGValue('spmbgid') && parseInt(this.getBGValue('spmbgid')) > 0) {
          this.$store.dispatch('fetchBetgame', this.getBGValue('spmbgid'))
        }
      }
    },
  },
  methods: {
    loadDeferredDashboardData () {
      if(!this.isBattle()) {
        if (this.$store.state.betgame && this.$store.state.betgame.season) {
          this.$store.dispatch('fetchQuestions', [])
        }
        if (!this.$store.state.answers || this.$store.state.updateAnswerCount) {
          this.$store.dispatch('updateAnswerCount', false)
          this.$store.dispatch('fetchUserAnswers', [])
        }
      }
      if(this.$store.state.user && (this.$store.state.missing_bets === undefined || this.$store.state.missing_bets === null || this.$store.state.missing_bets.length === 0)) {
        this.$store.dispatch('fetchUserBetgames', this.$store.state.user.id)
      }
      if(this.$store.state.geoData === null) {
        this.$store.dispatch('getGeoData', []).then(response => {
          if(this.$store.state.geoData) {
            localStorage.setItem('geoData', JSON.stringify(this.$store.state.geoData))
          }
        })
      } else {
        localStorage.setItem('geoData', JSON.stringify(this.$store.state.geoData))
      }
      this.$store.dispatch('fetchAppstauberConfig', '')
      if(this.$store.state.user) {
        localStorage.setItem('user', JSON.stringify(this.$store.state.user))
      }
      if(this.$store.state.betgame) {
        localStorage.setItem('betgame', JSON.stringify(this.$store.state.betgame))
        const c = this.$store.state.competitions.find(competition => competition.id === this.$store.state.betgame.competition.id)
        if (c) {
          localStorage.setItem('competition', JSON.stringify(c))
        }
      }
    },
    finishDashboardLoad () {
      const delay = this.$store.getters.hasCachedDashboardData ? 0 : 1500
      setTimeout(() => {
        const element = document.getElementById('pagebody')
        if (element) {
          element.classList.remove('bodybackground')
        }
        this.$store.dispatch('setShowLoadingOverlay', false)
        this.componentKey += 1
      }, delay)
    },
    hideSpecialQuestionMissingSolutionHint() {
      this.hideSpecialQuestionHintClicked = true
      window.localStorage.setItem('hideSpecialQuestionMissingSolutionHint', 1)
    },
    mailToBetgameAdmin() {
      window.location.href = 'mailto:' + this.$store.state.betgame.email
    },
    hideCreateWMBetgameAdClicked() {
      this.hideCreateWMBetgameAd = true
      window.localStorage.setItem('hideCreateWMBetgameAd1', 1)
    },
    hideCreateBetgameAdClicked() {
      this.hideCreateBetgameAd = true
      window.localStorage.setItem('hideCreateBetgameAd', 1)
    },
    copyBetgame(competition) {
      this.hideCreateWMBetgameAd = true
      window.localStorage.setItem('hideCreateWMBetgameAd1', 1)
      this.$gtag.event('Copy_betgame', {
        'event_category': 'create_betgame',
        'event_label': 'dashboard_copy_betgame',
        'dimension1': this.$store.state.betgame && this.$store.state.betgame.name ? this.$store.state.betgame.name : 'betgame not set',
        'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
        'dimension3': this.$store.state.betgame && this.$store.state.betgame.id ? this.$store.state.betgame.id : 'betgame id not set',
        'dimension5': this.$store.state.betgame && this.$store.state.betgame.type ? this.$store.state.betgame.type : 'betgame type not set'
      })
      this.$router.push('/createuserbetgame?type=1&competition=' + competition)
    },
    createBetgame() {
      this.hideCreateWMBetgameAd = true
      window.localStorage.setItem('hideCreateWMBetgameAd1', 1)
      this.$gtag.event('Create_betgame_start', {
        'event_category': 'create_betgame',
        'event_label': 'dashboard',
        'dimension1': this.$store.state.betgame && this.$store.state.betgame.name ? this.$store.state.betgame.name : 'betgame not set',
        'dimension2': this.$store.state.user && this.$store.state.user.source ? this.$store.state.user.source : 'user source not set',
        'dimension3': this.$store.state.betgame && this.$store.state.betgame.id ? this.$store.state.betgame.id : 'betgame id not set',
        'dimension5': this.$store.state.betgame && this.$store.state.betgame.type ? this.$store.state.betgame.type : 'betgame type not set'
      })
      this.$router.push('/mybetgames')
    },
    checkStatus (matches) {
      for (var i = 0; i < matches.length; i++) {
        const match = matches[i]
        if (match.status && (match.status.trim() === 'annulliert' || match.status.trim() === 'abgesagt' || match.status.trim() === 'Walkover'
            || match.status.trim() === 'verlegt' || match.status.trim() === 'Wertung' || match.status.trim() === 'nicht ausgetragen')) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
  .dashboard {
    width: 100%;
  }
  .dashboard-container {
    flex: 100%;
  }
  small {
    width: 100%;
    text-align: center;
    margin-bottom: -8px;

    @media screen and (min-width: 768px) {
      margin-bottom: -12px;
    }
  }
</style>
